// extracted by mini-css-extract-plugin
export default {"container":"style_container__08nVX","message":"style_message__qVNCO"};